import { debounce } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";

import { PartnersService } from "~/entity/Partners/api/service";

export interface IPartnerSelectOption {
  value: string;
  label: string;
}

const PAGE_SIZE = 50;

export const useGetPartnersForSelect = (enabled = true) => {
  const [options, setOptions] = useState<IPartnerSelectOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (!enabled) {
      setOptions([]);
      setSearch("");
      return;
    }

    let cancelled = false;

    setLoading(true);
    PartnersService.GET.list({
      page: 0,
      count: PAGE_SIZE,
      status: "ACTIVE",
      name: search || undefined,
    })
      .then((response) => {
        if (!cancelled) {
          setOptions(
            (response.data.partners || []).map((partner) => ({
              value: partner.id,
              label: partner.name,
            })),
          );
        }
      })
      .catch((error) => {
        console.error("Ошибка загрузки партнёров:", error);
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, search]);

  const onSearch = useMemo(
    () =>
      debounce((value: string) => {
        setSearch(value);
      }, 300),
    [],
  );

  const onOpenChange = useCallback((open: boolean) => {
    if (open) {
      setSearch("");
    }
  }, []);

  return { options, loading, onSearch, onOpenChange };
};
